import { render, staticRenderFns } from "./SetCustomDocEdit.vue?vue&type=template&id=4aefa547&scoped=true"
import script from "./SetCustomDocEdit.vue?vue&type=script&lang=js"
export * from "./SetCustomDocEdit.vue?vue&type=script&lang=js"
import style0 from "./SetCustomDocEdit.vue?vue&type=style&index=0&id=4aefa547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aefa547",
  null
  
)

export default component.exports